import {FormulaType} from '@mintdata-wsp/common/controllers/spreadsheet/formula/engine/FormulaType';
import {CurrentFunctionParam} from '@mintdata-wsp/common/controllers/spreadsheet/formula/operations/eval/EvalFormula';
import {ClientFunction} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import {ISheetValue} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {IValue} from '@mintdata/mint-kit/api/types/Value';

export class EvalStack
{
    private _values:Array<IValue | ISheetValue> = [];
    private _formulaType:FormulaType = FormulaType.RegularFormula;
    private _functions:ClientFunction[] = [];
    private _currentFunctionParam:CurrentFunctionParam = null;

    valuesLength():number
    {
        return this._values.length;
    }

    push(value:IValue | ISheetValue):void
    {
        this._values.push(value);
    }

    pop():IValue | ISheetValue
    {
        return this._values.pop();
    }

    pushFunction(cf:ClientFunction):void
    {
        this._functions.push(cf);
    }

    peekCurrentFunction():ClientFunction | null
    {
        const functions = this._functions;

        if( functions.length === 0 )
            return null;

        return functions[functions.length - 1];
    }

    isArrayFormula():boolean
    {
        return this._functions.filter(value => value.isArrayFormula).length > 0;
    }

    popFunction():void
    {
        this._functions.pop();
    }

    setCurrentFunctionParam(cfp:CurrentFunctionParam)
    {
        this._currentFunctionParam = cfp;
    }

    getCurrentFunctionParam():CurrentFunctionParam | null
    {
        return this._currentFunctionParam;
    }

    clearCurrentFunctionParam()
    {
        this._currentFunctionParam = null;
    }

    markIsLazyFormula():void
    {
        this._formulaType = FormulaType.LazyFormula;
    }

    markIsLiveFormula():void
    {
        this._formulaType = FormulaType.LiveFormula;
    }

    public isLazyFormula():boolean
    {
        return this._formulaType === FormulaType.LazyFormula;
    }

    public isLiveFormula():boolean
    {
        return this._formulaType === FormulaType.LiveFormula;
    }
}
